/* eslint-disable @next/next/no-img-element */
import classNames from 'classnames';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { FLAGS_CONFIG } from '../../brands/default/content/components/headerflags';
import ThemeContext from '../../providers/ThemeProvider';

const HeaderFlags = ({ countryCode, isMobileHidden }) => {
  const theme = useContext(ThemeContext);
  const componentClass = classNames('flag-container', {
    'flag-container--hidden': !theme.switches.showFlags,
    'flag-container--hidden-mobile': isMobileHidden,
  });

  if (FLAGS_CONFIG.length <= 1) return <></>;

  return (
    <div
      aria-label="Country Selection"
      className={componentClass}
      data-qa="countrySelection"
    >
      {FLAGS_CONFIG.map((flag) => {
        return (
          <Link href={flag.href} key={flag.countryCode}>
            <a href={flag.href}>
              <img
                alt={`${flag.countryName} Flag select`}
                aria-label={`${flag.countryName} Flag`}
                className={`flag ${
                  flag.countryCode === countryCode ? 'active' : ''
                }`}
                data-qa={`${flag.countryName}FlagSelection`}
                loading="lazy"
                src={`${flag.flagImg}`}
              />
            </a>
          </Link>
        );
      })}

      <style jsx>{`
        .flag-container {
          text-align: center;
          color: ${theme.colors.primary};
          font-size: 12px;
          text-transform: ${theme.text.transform};
        }

        .flag-container .flag {
          width: 46px;
          margin-left: 10px;
        }

        .flag-container .flag.active {
          border: 1px solid ${theme.colors.primary};
          padding: 2px;
          border-radius: 5px;
        }

        .flag-container--hidden {
          display: none;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .flag-container--hidden-mobile {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default HeaderFlags;

HeaderFlags.propTypes = {
  countryCode: PropTypes.string,
  isMobileHidden: PropTypes.bool,
};

HeaderFlags.propTypes = {
  countryCode: PropTypes.oneOf(['gb', 'ie']),
};
